/**
 * @copyright 2026 Fortee Custom Apparel Inc. All rights reserved.
 * @license PROPRIETARY - Unauthorized copying, modification, or distribution
 *          of this file is strictly prohibited. This software is protected
 *          under the Canadian Copyright Act (R.S.C., 1985, c. C-42).
 * @author Fortee Custom Apparel Inc. <info@fortee.ca>
 *
 * fortee-loader.js -- Idempotent Alpine.js + builder JS chain loader.
 * Loaded by each builder section. Detects existing Alpine, loads CDN if not
 * present, then loads all builder JS in guaranteed sequential order.
 */
/* ​‌​​​‌‌​‍​‌​​‌‌‌‌‍​‌​‌​​‌​‍​‌​‌​‌​​‍​‌​​​‌​‌‍​‌​​​‌​‌‍​​‌​‌‌​‌‍​​‌‌​​‌​‍​​‌‌​​​​‍​​‌‌​​‌​‍​​‌‌​‌‌​‍​​‌​‌‌​‌‍​‌​‌​‌‌​‍​​‌‌​​‌​‍​​‌​‌‌​‌‍​‌​​​​‌​‍​‌​​‌‌​​‍​‌​​​‌​​‍​‌​​‌​‌‌‍​‌​​​‌​‌‍​‌​‌‌​​‌‍​​‌​‌‌​‌‍​​‌‌​​​‌‍​‌‌​​‌​‌‍​​‌‌​‌​​‍​​‌‌​​‌‌‍​​‌‌​‌​​‍​‌‌​​​​‌‍​‌‌​​‌​‌‍​‌‌​​​‌‌‍​​‌‌​​​​‍​​‌‌​​​‌‍​​‌‌​​​‌‍​‌‌​​​‌​ */
(function() {
  // Guard: only run once per page
  if (window.__forteeLoaded) return;
  window.__forteeLoaded = true;

  // Detect Alpine: check window.Alpine OR deferred scripts that bundle it.
  // Many Shopify themes (T4S, Dawn variants) bundle Alpine in main.js loaded
  // with defer, so window.Alpine won't exist yet at this point.
  var alpinePresent = typeof window.Alpine !== 'undefined';
  if (!alpinePresent) {
    var scripts = document.querySelectorAll('script[src]');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].getAttribute('src') || '';
      // Theme main.js bundles (T4S and similar) include Alpine + plugins
      if (/main\.js/.test(src) && scripts[i].defer) {
        alpinePresent = true;
        break;
      }
      // Explicit Alpine script already in page
      if (/alpinejs|alpine\.min\.js|alpine\.js/.test(src)) {
        alpinePresent = true;
        break;
      }
    }
  }

  // Version check: abort if Alpine 2.x detected
  if (alpinePresent && window.Alpine && window.Alpine.version && window.Alpine.version.indexOf('2.') === 0) {
    console.error('[FORTEE] Alpine 2.x detected -- builder requires Alpine 3.x');
    return;
  }

  // Sequential script loader using onload Promise chain
  function loadScript(src) {
    return new Promise(function(resolve) {
      // Skip if already loaded
      if (document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = false; // CRITICAL: guarantees document-order execution
      s.onload = resolve;
      s.onerror = function() {
        console.error('[FORTEE] Failed to load: ' + src);
        resolve(); // Don't block chain on failure
      };
      document.head.appendChild(s);
    });
  }

  // Asset base URL -- set by section Liquid before this script runs
  var base = window.__forteeAssetBase || '';

  var chain = Promise.resolve();

  // 1. Alpine plugins (only if Alpine not already present)
  if (!alpinePresent) {
    ['persist', 'collapse', 'focus'].forEach(function(plugin) {
      chain = chain.then(function() {
        return loadScript('https://cdn.jsdelivr.net/npm/@alpinejs/' + plugin + '@3.14.9/dist/cdn.min.js');
      });
    });
  }

  // 2. Builder JS files (register alpine:init listeners)
  ['builder-components.js', 'builder-shared-services.js'].forEach(function(f) {
    chain = chain.then(function() {
      var versioned = (window.__forteeAssetUrls || {})[f];
      return loadScript(versioned || (base + f));
    });
  });

  // 3. Mode-specific JS (set by section Liquid, e.g. 'single-builder.js')
  if (window.__forteeModeScript) {
    chain = chain.then(function() {
      return loadScript(base + window.__forteeModeScript);
    });
  }

  // 4. Money utility
  chain = chain.then(function() {
    var moneyUrl = (window.__forteeAssetUrls || {})['alpine-money-magic.js'];
    return loadScript(moneyUrl || (base + 'alpine-money-magic.js'));
  });

  // 5. Alpine core (only if not already present -- must load LAST)
  if (!alpinePresent) {
    chain = chain.then(function() {
      return loadScript('https://cdn.jsdelivr.net/npm/alpinejs@3.14.9/dist/cdn.min.js');
    });
  }

  // 6. Error boundary
  chain.catch(function(err) {
    console.error('[FORTEE] Loader chain failed:', err);
  });
})();
